/**
 * Validate component config by schema
 *
 * Follows limited examples in JSON schema for wider support in future
 *
 * {@link https://ajv.js.org/json-schema.html#compound-keywords}
 * {@link https://ajv.js.org/packages/ajv-errors.html#single-message}
 *
 * @template {Partial<Record<keyof ConfigurationType, unknown>>} ConfigurationType
 * @param {Schema<ConfigurationType>} schema - The schema of a component
 * @param {ConfigurationType} config - Component config
 * @returns {string[]} List of validation errors
 */
export function validateConfig(schema, config) {
  const validationErrors = []

  // Check errors for each schema
  for (const [name, conditions] of Object.entries(schema)) {
    const errors = []

    // Check errors for each schema condition
    if (Array.isArray(conditions)) {
      for (const { required, errorMessage } of conditions) {
        if (!required.every((key) => !!config[key])) {
          errors.push(errorMessage) // Missing config key value
        }
      }

      // Check one condition passes or add errors
      if (name === 'anyOf' && !(conditions.length - errors.length >= 1)) {
        validationErrors.push(...errors)
      }
    }
  }

  return validationErrors
}

/**
 * @import { Schema } from './index.mjs'
 */
